import { useLayoutEffect, useState } from 'react'

export const useResize = (): [number, boolean] => {
  const [lastWidth, setlastWidth] = useState(window.innerWidth)
  const [lastHeight, setlastHeight] = useState(window.innerHeight)
  const [intViewportHeight, setintViewportHeight] = useState(window.innerHeight)
  const [scrollable, setscrollable] = useState(false)
  const handleResize = () => {
    setscrollable(false)
    if (window.innerHeight < 667) {
      const isSameSize =
        window.innerWidth === lastWidth && window.innerHeight === lastHeight
      // console.log({ isSameSize })
      if (!isSameSize) {
        if (
          window.innerWidth === lastWidth &&
          window.innerHeight < lastHeight - 100
        ) {
          // console.log(
          //   'window.innerHeight < lastHeight - 100',
          //   window.innerHeight < lastHeight - 100,
          //   window.innerHeight,
          //   lastHeight,
          // )
          setscrollable(true)
        } else {
          setlastHeight(window.innerHeight)
          setlastWidth(window.innerWidth)
          setintViewportHeight(window.innerHeight)
        }
      }
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
  }, [lastHeight, lastWidth])

  return [intViewportHeight, scrollable]
}
